<template>
  <div class="addStyle">
    <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="90px" size="small" >
      <el-form-item label="问题截图:">
        <div class="MQcut">
          <div v-for="(item,index) in base64List" class="uploadpic" :key="index" @mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)">
            <img :src="item.url" alt="截图" @click="startKss(index,$event)" >
            <div class="delete" v-if="showDelete && item.hasKss && imageIndex == index" @click="deleteImage(index)">
              <i class="el-icon-delete"  ></i>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="问题描述:" prop="checkContent">
        <el-input v-model="addForm.checkContent" type="textarea" rows="4"  maxlength="200" show-word-limit style="max-height:490px" placeholder="请填写问题描述" ></el-input>
      </el-form-item>
      <el-form-item label="审图要点:" class="itemStyle">
        <template #label>
          <div class="labelStyle">
            <span>审图要点:</span>
            <el-button class="rcStyle" type="primary" plain size="mini" @click="showImgPoint" >关联审图要点</el-button >
          </div>
        </template>
        <el-input style="margin-left:0" type="textarea" v-model="addForm.drawingReviewPoints" readonly ></el-input>
      </el-form-item>
      <el-form-item label="关联文件:" class="associatedFileStyle">
        <template #label>
          <div class="labelStyle">
            <span>关联文件:</span>
            <el-button class="rcStyle" type="primary" plain size="mini" @click="showAssociatedFile" >关联文档目录树</el-button >
            <el-button class="rcStyle" type="primary" plain size="mini" @click="uploadFiles" >本地上传</el-button >
          </div>
        </template>
        <ul>
          <li v-for="(item,index) in floderData" :key="index">
            <p class="fileNamestyle" :title="item.fileName">{{item.fileName}}</p>
            <p style="margin-top:3px">
              <img :src="down" alt="下载" style="margin-right: 8px" @click="todown(item)">
              <img :src="del" alt="删除" style="margin-right: 5px" @click="todel(index)">
            </p>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="意见类型:" prop="qmTypeId" key="qmTypeId">
        <el-select v-model="addForm.qmTypeId" placeholder="请选择意见类型">
          <el-option v-for="item in dicList.checkTypeList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="严重等级:" prop="problemTypeId" key="problemTypeId">
        <el-select v-model="addForm.problemTypeId" placeholder="请选择严重等级">
          <el-option v-for="item in dicList.severityLevelList" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="阶 段:" v-if="stageNameBoolean">
        <div v-if="stageName" >{{ stageName }}</div>
        <el-select v-else v-model="addForm.stageId" placeholder="请选择阶段" >
          <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='阶段').optionalValues" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item  label="专 业:"  prop="specId">
        <el-select  v-model="addForm.specId" placeholder="请选择专业" @change="addForm.multiSpecListspecIds=[]" filterable>
          <el-option v-for="item in dicList.specList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item  label="专 业:" prop="multiSpecListspecIds">
        <!-- <div v-if="!addForm.specId">请先选择专业</div> -->
        <el-select v-model="addForm.multiSpecListspecIds" placeholder="请选择专业" multiple collapse-tags filterable>
          <el-option v-for="item in multiSpecList" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item  label="子 项:"  v-if="childNameBoolean">
        <div v-if="childName">{{ childName }}</div>
        <el-select v-else v-model="addForm.stageChildId" placeholder="请选择子项">
          <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '子项').optionalValues" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="修改方:" >
        <el-select v-model="addForm.modifierIds" filterable placeholder="请选择修改方" clearable>
          <el-option-group
            v-for="group in dicList.modifierList"
            :key="group.label"
            :label="group.label"
          >
             <el-option v-for="item in group.options" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item style="text-align: end;">
        <el-button size="mini" @click="closeModelq(true)">取消</el-button>
        <el-button v-loading="addLoading"  size="mini" title="模型问题" type="primary" @click="addnotations">创建</el-button >
      </el-form-item>
    </el-form>
    <check-img-point v-if="imgPoint" ref="checkImgPoint" />
    <associated-file v-if="associatedFileShow" ref="associatedFile"/>
  </div>
</template>

<script>
const addParamsForm = () => ({
  checkContent:'',//问题描述
  drawingReviewPoints:'',//审图要点
  qmTypeId:'',//意见类型
  problemTypeId:'',//严重等级
  stageId:'',//阶段
  specId:'',//专业
  multiSpecListspecIds:[],//跨专业
  stageChildId:'',//子项
  modifierIds:'',//修改人
});
import { mapState } from "vuex";
import notationService from "@/CommonDP/service/file-service"
import question from "@/xgzdService/question-service"
import iconImage from "@/CommonDP/assets/notation/icon-cutImg.png"
import checkImgPoint from "@/CommonDP/components/checkImgPoint/index.vue";
import Kscreenshot from "@/utils/kscreenshot/src/kss";
import associatedFile from "@/CommonDP/components/associatedFile/index.vue";
import {  downloadUrltoken } from "@/utils";
export default {
  components:{checkImgPoint,associatedFile},
  props:['type'],
  data(){
    return{
      dicList:[],//添加批注的字典

      stageName:'',
      stageNameBoolean:false,
      specName:'',
      specNameBoolean:false,
      multiSpecName:"",
      multiSpecNameBoolean:false,
      childName:'',
      childNameBoolean:false,

      prjID:'',
      fileId:'',
      addLoading:false,
      base64List:[
        {url:iconImage,hasKss:false},
        {url:iconImage,hasKss:false},
        {url:iconImage,hasKss:false}
      ],
      imageIndex:'',
      rules:{
        problemTypeId:[
          { required: true, message: "严重等级不可为空", trigger: "change" },
        ],
        checkContent:[
          { required: true, message: "问题描述不可为空", trigger: "blur" },
        ],
        qmTypeId:[
          { required: true, message: "意见类型不可为空", trigger: "change" },
        ],
        multiSpecListspecIds: [
          { required: true, message: "请选择专业", trigger: "change" }
        ]
      },
      addForm:addParamsForm(),
      imgPoint:false,
      fileList:[],
      picList:[],
      showDelete:false,
      autoScreenshotMd5:'',//自动截图
      coordinate:'',
      mark3d:'',
      viewPoint3d:'',
      associatedFileShow:false,
      floderData:[],
      down:require('@/CommonDP/assets/issueMgDown.png'),
      del:require('@/CommonDP/assets/issueMgDel.png'),
    }
  },
  computed:{
    ...mapState({
      dwgdata: state => state.monge.dwgdata,
      modeldata: state => state.monge.modeldata,
      spaceOfDwgData:state => state.monge.spaceOfDwgData,
      dwgModelId:state => state.monge.dwgModelId,
      modelPageFileName:state => state.monge.modelPageFileName,
      floderObj: (state) => state.uploaderAnnotation.floderObj,
      hasDwg: state => state.monge.hasDwg
    }),
    multiSpecList(){
      if(this.dicList.specList&&this.dicList.specList.length>0&&this.addForm.multiSpecListspecIds)
      return this.dicList.specList.filter(ele =>ele.id != this.addForm.multiSpecListspecIds)
    },
    addParams:{
      get(){
        const {checkContent,drawingReviewPoints,qmTypeId,problemTypeId,modifierIds,stageId,specId,multiSpecListspecIds,stageChildId}=this.addForm
        const source = "WEB端";
        const qmType = this.dicList.checkTypeList?.find(item => item.id === qmTypeId).cnName ||"";
        const problemType = this.dicList.severityLevelList?.find( item => item.id === problemTypeId ).cnName||"";
        let specName = this.dicList.specList&&specId?this.dicList.specList.find(item => item.id === specId).cnName:"";

        let modifierList=[]//修改方改为数组
        let multiSpecList=[]
        if(modifierIds){
          let list = [...this.dicList.modifierList[0].options, ...this.dicList.modifierList[1].options]
          let selectItem = list.find(sor=>sor.id == modifierIds)
          let obj={modifierId:modifierIds, modifierName:selectItem.cnName, type:selectItem.remark };
          modifierList.push(obj)
        }
        if(multiSpecListspecIds.length){
          multiSpecListspecIds.forEach(ele=>{
            let obj={specId:ele, specName:this.dicList.specList.find(sor=>sor.id == ele ).cnName }
            multiSpecList.push(obj)
          })
        }
        

        let layoutName = "";//布局空间
        let viewPoint ="";
        let autoScreenshotMd5 ="";
        let anchorPoint ="";
        let modelFileId="";
        let modelPageFileName = ""
        if(this.type == 'dwg'){
          layoutName = JSON.parse(this.spaceOfDwgData)
          autoScreenshotMd5= this.autoScreenshotMd5
        }else if(this.type == 'rvt'){
          viewPoint =JSON.stringify(this.viewPoint3d)
          autoScreenshotMd5= this.autoScreenshotMd5
        }else if(this.type == 'pdf'){
          anchorPoint =this.$parent.$parent.$refs.iframeID.contentWindow.PDFViewerApplication.page
        }else if(this.type == 'modeldwg'){
          modelFileId =this.dwgModelId;
          modelPageFileName =this.modelPageFileName
          autoScreenshotMd5= this.autoScreenshotMd5
        }
        let annexFileList =[]
        if(!!this.floderData&&this.floderData.length){
          this.floderData.forEach(ele=>{
            let obj={fileId:ele.fileId,fileName:ele.fileName,id:'',uploadType:ele.uploadType}
            annexFileList.push(obj)
          })
        }
        const params = {
          prjId: this.prjID,
          fileList:this.fileList,
          checkContent,
          qmTypeId,
          qmType,
          problemTypeId,
          problemType,
          modifierList,
          drawingReviewPoints,
          source,
          multiSpecList,
          // stageId,
          // stageName,
          specId,
          specName,
          // stageChildId,
          // stageChildName,
          picMd5List:this.picList,
          layoutName,
          coordinate:this.coordinate,
          autoScreenshotMd5,
          viewPoint,
          anchorPoint,
          annexFileList,
          modelFileId,
          modelPageFileName,
        }
        return params;
      }
    },
  },
  watch: {
    floderObj(newValue) {
      if (newValue.fileId) {
        this.floderData.push(newValue)
      } else {
        this.floderData = []
      }
    },
  },
  created() {
    this.init();
  },
  methods:{
    async init(){
      if(this.type == 'dwg'){
        this.prjID = JSON.parse(this.dwgdata).prjID;
        this.fileId = JSON.parse(this.dwgdata).fileId
      }else if(this.type == 'rvt' ||this.type == 'modeldwg'){
        this.mark3d= "";
        if(!!this.modeldata.fileObj){
          this.fileId ='';
          this.prjID =this.modeldata.prjId;
        }else {
          this.fileId =this.modeldata.fileId;
          this.prjID =this.modeldata.prjId;
        }
        this.AddMark2d();
      }else{
        this.fileId = this.$route.query.f;
        this.prjID = this.$route.query.prjId;
      }
      await this.queryDic()
    },
    initSpecifiedFiled () {
      this.initFiledWithCnName('checkTypeList', 'qmTypeId', '其他')
      this.initFiledWithCnName('severityLevelList', 'problemTypeId', 'D')
      this.initFiledWithCnName('specList', 'specId', '其他')
      this.initFiledWithCnName('specList', 'multiSpecListspecIds', '其他')
    },
    initFiledWithCnName(dictProp, formProp, cnName) {
      const dict = this.dicList
      if (Array.isArray(dict?.[dictProp])) {
        const other = dict?.[dictProp].find(item => item.cnName === cnName)
        if (other && !this.addForm[formProp]) {
          this.addForm[formProp] = other.id
        }
        if(formProp == 'multiSpecListspecIds') {
            this.$nextTick(() => { this.addForm[formProp] = [other.id] })
        }
        
      }
    },
    //新增时候的字典
    async queryDic(){
      const res = await question.getNotationDic(this.prjID,this.fileId);
      if (res.result === "0") {
        let list = res.data || {};
        // 处理修改方
        let roleList = { label: '角色', options: res.data.roleList };
        let userList = { label: '用户', options: res.data.userList };
        list.modifierList = [roleList, userList]
        this.dicList = list;
        this.initSpecifiedFiled()
        // this.addForm.qmTypeId =res.data.qmTypeId;
        // this.addForm.problemTypeId =res.data.problemTypeId;
        // this.addForm.modifierId =res.data.modifierId;
        //意见类型默认第一条
        // this.addForm.qmTypeId = this.addForm.qmTypeId || this.dicList.checkTypeList[0].id;
        //严重程度默认第一条
        // this.addForm.problemTypeId = this.addForm.problemTypeId || this.dicList.severityLevelList[0].id;
        // if(this.dicList.specStageChildVos){
        //   if(this.dicList.specStageChildVos.some(ele=>ele.name=='阶段')){
        //     this.stageName = this.dicList.specStageChildVos.find(ele=>ele.name=='阶段').defaultValue ;
        //     this.stageNameBoolean = true
        //   }else{
        //     this.stageName =""
        //     this.stageNameBoolean = false
        //   }
  
        //   if(this.dicList.specStageChildVos.some(ele=>ele.name=='专业')){
        //     this.specName = this.dicList.specStageChildVos.find(ele=>ele.name=='专业').defaultValue;
        //     this.specNameBoolean = true
        //   }else{
        //     this.specName = "";
        //     this.specNameBoolean = false
        //   }
  
        //   if(this.dicList.specStageChildVos.some(ele=>ele.name=='跨专业')){
        //     this.multiSpecName = this.dicList.specStageChildVos.find(ele=>ele.name=='跨专业').defaultValue
        //     this.multiSpecNameBoolean = true
        //   }else{
        //     this.multiSpecName = ""
        //     this.multiSpecNameBoolean = false
        //   }
  
        //   if(this.dicList.specStageChildVos.some(ele=>ele.name=='子项')){
        //     this.childName = this.dicList.specStageChildVos.find(ele=>ele.name=='子项').defaultValue ;
        //     this.childNameBoolean = true
        //   }else{
        //     this.childName = "" ;
        //     this.childNameBoolean = false
        //   }
        // }
      }
    },
    AddMark2d() {
      Monge.Model.Mark.clear();
      Monge.Model.Mark.active(0xff0000, (type, mark) => {
        if (type === "done") {
          this.mark3d = mark;
        }
      });
      this.viewPoint3d = Monge.Model.Camera.getViewport();
    },
    closeModelq(){
      if(this.type =="dwg" ||this.type == 'modeldwg'){
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive()
      }else if(this.type =="rvt"){
        Monge.Model.Mark.clear();
        Monge.Model.Mark.deactive()
      }
      this.floderData=[]
      this.$emit("closeAdd",'')
    },
    mouseenter(index){
      this.imageIndex = index
      this.showDelete=true
    },
    mouseleave(index){
      this.imageIndex = index
      this.showDelete=false
    },
    deleteImage(index){
      this.base64List[index].url=iconImage;
      this.base64List[index].hasKss =false
    },
    startKss(index,event){
      //图纸截图
      if(this.type == 'dwg'){
        let cutpic = "";
        Monge.Map.screenCapture(1, canvas => {
          let kss = new Kscreenshot({
            endCB: imgs => {
              cutpic = imgs;
              this.getAddCutPicList(cutpic,index);
            }
          });
          kss.startScreenShot(canvas);
        });
      }else if(this.type == 'rvt'){
        let cutpic = "";
        if(!this.hasDwg){
          Monge.Model.screenCapture(1, (canvas) => {
            const kss = new Kscreenshot({
              endCB: (imgs) => {
                cutpic = imgs;
                this.getAddCutPicList(cutpic, index);
              }
            });
            kss.startScreenShot(canvas);
          });
        }else{
          Monge.screenCapture((canvas) => {
            const kss = new Kscreenshot({
              endCB: (imgs) => {
                cutpic = imgs;
                this.getAddCutPicList(cutpic, index);
              }
            });
            kss.startScreenShot(canvas);
          });
        }
      }else if(this.type == 'modeldwg'){
        let cutpic = "";
        Monge.screenCapture(canvas => {
          let kss = new Kscreenshot({
            endCB: imgs => {
              cutpic = imgs;
              this.getAddCutPicList(cutpic,index)
            }
          });
          kss.startScreenShot(canvas);
        });
      }else{
        this.$emit("startScreenShot",index,event)
      }
    },
    getAddCutPicList(cutimglist,index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true
    },
    addnotations(){
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          this.addLoading = true;
          this.picList = [];
          for(let index in this.base64List){
            if(this.base64List[index].hasKss){
              this.picList.push(await this.getFileMD5(this.base64List[index].url));
            }
          }
          //图纸添加批注
          if(this.type == 'dwg'){
            this.fileList = [ { fileId:JSON.parse(this.dwgdata).fileId, fileName: JSON.parse(this.dwgdata).fileName, fileVersion: JSON.parse(this.dwgdata).fileVersion } ];
            Monge.Map.Annotation.setCurText(this.addForm.checkContent);
            this.$emit("closeAdd")
          }else if(this.type == 'rvt'){//模型添加批注
            if(!this.mark3d){
              this.$message({ message: "请点击模型创建锚点", type: "warning" });
              this.addLoading = false;
              return;
            }
            if(!!this.modeldata.fileObj){
              this.fileList=this.modeldata.fileObj.map(ele=>{
                return {fileId:ele.folderID,fileName:ele.folderName,fileVersion:ele.rvtVersion}
              })
            }else{
              this.fileList = [{ fileId:this.modeldata.fileId, fileName: this.modeldata.fileName, fileVersion: this.modeldata.rvtVersion }];
            }
            this.coordinate = JSON.stringify(this.mark3d);
            await this.screenModelCapture()
          }else if(this.type == 'modeldwg'){
            if(!!this.modeldata.fileObj){
              this.fileList=this.modeldata.fileObj.map(ele=>{
                return {fileId:ele.folderID,fileName:ele.folderName,fileVersion:ele.rvtVersion}
              })
            }else{
              this.fileList = [{ fileId:this.modeldata.fileId, fileName: this.modeldata.fileName, fileVersion: this.modeldata.rvtVersion }];
            }
            Monge.Map.Annotation.setCurText(this.addForm.checkContent);
            this.$emit("closeAdd")
          }else{
            this.coordinate = ""
            this.fileList = [ { fileId:this.$route.query.f, fileName: this.$route.query.title, fileVersion: this.$route.query.fileVersion } ];
            await this.addFinal()
          }
        }
      })
    },
    //图纸需要用到的方法
    screenCaptureByBox(data){ 
      this.coordinate = JSON.stringify(data.data)||'';//云线或锚点数据
      if (data.bbox){
        Monge.Map.screenCapture(false, async (canvas) => {
          this.autoScreenshotMd5 = await this.getFileMD5(canvas);
          await this.addFinal()
        })
      }
    },
    //模型
    screenModelCapture(){
      Monge.Model.screenCapture(false,async (canvas) => {
        this.autoScreenshotMd5 = await this.getFileMD5(canvas);
        await this.addFinal()
      });
    },
    async addFinal(){
      try {
        const res = await question.notationAdd(this.addParams);
        if (res.result === "0") {
          this.$message({ message: "创建成功！", type: "success" });
          if(this.type == 'dwg' ){
            Monge.Map.Annotation.deactive();
          }else if(this.type == 'rvt'){
            Monge.Model.Mark.deactive()
          }else if(this.type == 'modeldwg'){
            Monge.Map.Annotation.deactive();
            Monge.Model.Mark.deactive()
          }
          this.addLoading = false;
          this.base64List.forEach(ele=>{
            ele.url=iconImage;
            ele.hasKss = false
          })
          this.floderData=[]
          const { specId, problemTypeId, qmTypeId } = this.addForm 
          this.addForm = addParamsForm()
          this.addForm.specId = specId
          this.addForm.problemTypeId = problemTypeId
          this.addForm.qmTypeId = qmTypeId
          this.$emit("closeAdd",'list')
          // 关闭创建批注高亮 打开批注列表高亮 批注列表展示出来
        }

      } catch (e) {
        console.log(e);
        this.addLoading = false;
      }
    },
    
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      let res = await notationService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      let mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      let ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ia], { type: mimeString });
      return blob;
    },
   
    showImgPoint(){
      this.imgPoint = true;
      this.$nextTick(() => {
        this.$refs.checkImgPoint.showDialog();
        this.$refs.checkImgPoint.getAlldata();
      });
    },
    //  获取点击的审图要点数据
    getPointInfo(val) {
      this.addForm.drawingReviewPoints = val.mainPoint || "";
      this.imgPoint = false;
    },
    showAssociatedFile(){
      this.associatedFileShow = true;
      this.$nextTick(() => {
        this.$refs.associatedFile.showDialog();
      });
    },
    // 关联文档数据
    getAssociatedFile(val){
      this.associatedFileShow = false;
      let arr1= val
      let arr2 = this.floderData
      let arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      let isfloderData = [...arr1, ...arr2.filter(({ fileName }) =>!arr1fileNames.has(fileName))];
      let isnotfloderData = [...arr2.filter(({ fileName }) =>arr1fileNames.has(fileName))];
      this.floderData=isfloderData
      for(let key in isnotfloderData){
        setTimeout(()=>{
          this.$message.warning(`文件${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
        },10)
      }
    },
    // 本地上传
    uploadFiles(){
      this.$store.dispatch("annotationUploadFloderData", this.floderData);
      this.$store.dispatch("annotationUploadType", new Date().getTime());
    },
    todown(row){
      const prjId = this.$route.query.prjId;
      const fileId = row.fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = fileUrl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    todel(index){
      const obj = {};
      this.floderData = this.floderData.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      this.floderData.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.addStyle{
  width: 100%;
  height: 100%;
  padding-right: 7px;
  overflow: hidden;
  overflow-y: auto;
  .MQcut{
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic{
      width: 75px;
      height: 75px;
      margin-right: 5px;
      cursor: pointer;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
      .delete{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        z-index: 1px;
        cursor: pointer;
        i{
          font-size:20px;
          color: #fff;
        }
      }
    }
  }
  .itemStyle {
    width: 100%;
    /deep/.el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    /deep/.el-form-item__content {
      margin-top: 30px;
    }
  }
  .associatedFileStyle{
    width: 100%;
    /deep/.el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    /deep/.el-form-item__content {
      margin-top: 30px;
    }
    li{
      display: flex; 
      justify-content: space-between;
      color:#3873FE;
      cursor: pointer;
      border: 1px solid #ffffff00;
      .fileNamestyle{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 200px;
        padding-left: 5px;
      }
    }
    li:hover{
      background:#EEF1FF;
    }
  }
  .labelStyle {
    font-size: 14px;
    line-height: 28px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    margin-left: 20px;
    > span {
      font-size: 14px;
      line-height: 28px;
      margin-right: 10px;
    }
  }
  /deep/.el-radio{
    margin-right: 10px;
  }
  /deep/.el-select{
    width: 100%;
  }
}
</style>